 import * as constants from './constants';
 import userRequest, {
     userApi
 } from 'common/request';
 const changeCourseInfoList = (infoList) => ({
     type: constants.CHANGE_COURSEEXPER_LIST_DATA,
     infoList
 });
 export const changeCourseInfo = (info, sid) => ({
     type: constants.CHANGE_COURSEEXPER_DATA,
     info,
     sid
 });
 const changeExcellentList = (excellentList) => ({
     type: constants.CHANGE_EXCELLENT_LIST,
     excellentList
 })
 const changeAttachmentList = (attachmentList) => ({
     type: constants.CHANGE_ATTACHMENT_LIST,
     attachmentList
 })
 const evil = (fn) => {
     var Fn = Function; //一个变量指向Function，防止有些前端编译工具报错
     return new Fn('return ' + fn)();
 }
 const changeCollect = (collect) => ({
     type: constants.CHANGE_COLLECT,
     collect
 })
 export const getCourseWatched=(course_id) =>{
     return (dispatch)=>{
         userRequest.get(window.AppConfig.mainIP+userApi.getCourseWatch+`${course_id}`).then((res)=>{})
     }
 };
 export const getCourseInfo = (course_id) => {
     return (dispatch) => {
         userRequest.get(window.AppConfig.mainIP + userApi.courseDetail, {
             course_id
         }).then((res) => {
             if (res.code === 0) {
                 let sid = '';
                 if (res.data.subject) {
                     sid = res.data.subject[0].id;
                 }

                 //获取优秀作品
              
                  dispatch(getCourseExcellent(course_id))
                  dispatch(changeCourseInfo(res.data, sid))
                  dispatch(changeCourseInfoList(res.data))
              
                 if (res.data.attachments) {
                     
                   let attachments ={}
                    try
                      {
                      //在这里运行代码
                         attachments = JSON.parse(res.data.attachments);
                      }
                    catch(err)
                      {
                      //在这里处理错误
                        attachments ={}
                      }
                      dispatch(changeAttachmentList(attachments));
                   
                 }
             }
         })
     }
 }




 //优秀作品
 //
 export const getCourseExcellent = (course_id) => {
     return (dispatch) => {
         userRequest.get(window.AppConfig.mainIP + userApi.getCourseExcellent, {
             course_id
         }).then((res) => {
             if (res.code === 0 && res.data.length !== 0) {
                 dispatch(changeExcellentList(res.data))
             }else{
                //没有优秀作品设置为空
                dispatch(changeExcellentList(''))
             }
         })
     }
 }


 

 //查询是否收藏
 export const getRecord = (course_id, user_id) => {
     return (dispatch) => {
         userRequest.get(window.AppConfig.mainIP + userApi.getRecord, {
             type: 'collect',
             course_id,
             user_id
         }).then((res) => {
             if (res.code === 0) {

                 if (res.data.models && res.data.models.length !== 0) {
                     dispatch(changeCollect(true))
                 } else {
                     dispatch(changeCollect(false))
                 }
             }
         })
     }
 }
 //添加收藏 addRecord
 export const addRecord = (course_id, user_id) => {
     return (dispatch) => {
         userRequest.post(window.AppConfig.mainIP + userApi.addRecord, {
             type: 'collect',
             course_id,
             user_id
         }).then((res) => {
             if (res.code === 0) {
                 dispatch(changeCollect(true))
                 
             }
         })
     }
 }
 //删除收藏 delRecord
 export const delRecord = (course_id, user_id) => {
     return (dispatch) => {
         userRequest.post(window.AppConfig.mainIP + userApi.delRecord, {
             type: 'collect',
             course_id,
             user_id
         }).then((res) => {
             if (res.code === 0) {
                 dispatch(changeCollect(false))
             }
         })
     }
 }